import ViewerVM from './viewer-vm';

export default {
  init(node) {
    const vm = new ViewerVM({
      coursework_entry: JSON.parse(node.dataset.courseworkEntryJson),
      course_list: JSON.parse(node.dataset.courseListJson),
      coursework_list: JSON.parse(node.dataset.courseworkListJson),
      user_type: node.dataset.userType,

      referrer: {
        title: 'Gallery',
        action: item => {
          const searchParams = Kadenze.Util.getURLParams(
            window.location.search
          );

          const courseSlug = (
            !_.isEmpty(searchParams['browsing_scope']) &&
              searchParams['browsing_scope'] === 'global'
          ) ?
            'all' :
            item.courseworkEntry().course.slug();

          const courseworkSlug = (
            courseSlug === 'all' || (
              !_.isEmpty(searchParams['browse']) &&
                searchParams['browse'] === 'all'
            )
          ) ?
            'all' :
            item.courseworkEntry().coursework.slug();

          window.location = Kadenze.Routes
            .course_gallery_coursework_overview_path(
              courseSlug,
              courseworkSlug
            );
        }
      }
    })

    ko.applyBindings(vm, node);
  }
};

